module.exports = __webpack_public_path__ + "img/pieceOneImg2.be8ae74.webp";